export class DragDropUpload {
  constructor(options) {
    this._then = this._defaultThen;
    this.target = options.target;
    this.action = options.action;
    this.data = options.data || {};
    this.upqueue = [];
    this.uplock = null;
    this.name = options.name || '';
    this._accept = options.accept;
    this._resolve = null;
    this._reject = null;
    this._updrop = null;
    this._upfile = null;
    this._spinner = null;
    this._init();

    window.test = this;
  }

  // (A) Инициализация Drag-Drop загрузчика
  _init() {
    this.uplock = false;
    this._exp_handeler = this._exp();
    // (A1) Добавление CSS класса
    this.target.classList.add('upwrap');

    // (A2) Создание HTML интерфейса для перетаскивания файлов
    this.target.innerHTML = `<div class="updrop">Перенесите файл или нажмите</div>
      <div class="spinner-border m-a text-secondary" role="status" hidden> <span class="visually-hidden">Loading...</span> </div>`;
    this._updrop = this.target.querySelector('.updrop');
    this._spinner = this.target.querySelector('.spinner-border');

    // (A3) Подсветка зоны при перетаскивании
    this._updrop.ondragenter = (event) => this._highlight(event);
    this._updrop.ondragleave = (event) => this._unhighlight(event);

    // (A4) Действия при перетаскивании и сбросе файла
    this._updrop.ondragover = (event) => this._preventDefaults(event);
    this._updrop.ondrop = (event) => this._handleDrop(event);

    this._upfile = document.createElement('input');
    this._upfile.name = `files[upload][${this.name}]`;
    this._upfile.type = 'file';
    this._upfile.accept = this._accept;
    this._upfile.classList.add('d-none');

    this.target.append(this._upfile);

    this._upfile.addEventListener('change', this._onChange.bind(this));
    this._updrop.addEventListener('click', () => this._upfile.click());
  }

  clearUpfile() {
    this._upfile.files = new DataTransfer().files;
    this.reload();
  }

  reload() {
    this.uplock = false;
    this._updrop.hidden = false;
    this._spinner.hidden = true;
  }

  async _exp() {
    const linkClass = this;
    return new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    }).then((response) => {
      if (linkClass._then) linkClass._exp_handeler.then(linkClass._then);
      return response;
    });
  }

  _defaultThen(response) {
    // return new ModalManager({ response: response.answer }).renderModal();
    // window.location.href = "/view/manager/manager-sale.php?number=" + xhr.response.slice(2);
  }

  _highlight(event) {
    event.preventDefault();
    event.stopPropagation();
    this._updrop.classList.add('highlight');
  }

  _unhighlight(event) {
    event.preventDefault();
    event.stopPropagation();
    this._updrop.classList.remove('highlight');
  }

  _preventDefaults(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  _handleDrop(event) {
    this._preventDefaults(event);
    this._unhighlight(event);

    if (!event.dataTransfer || !event.dataTransfer.files || event.dataTransfer.files.length === 0) {
      console.error('Нет доступных файлов для загрузки через drag-and-drop');
      alert('Ошибка: файлы не переданы!');
      return;
    }

    this._queue(event.dataTransfer.files);
  }

  // (B) Очередь файлов для загрузки
  _queue(files) {
    this._updrop.hidden = true;
    this._spinner.hidden = false;

    const dataTransfer = new DataTransfer();
    for (let file of files) {
      console.log('Добавление файла в очередь:', file.name);
      this.upqueue.push(file);
      dataTransfer.items.add(file);
    }

    this._upfile.files = dataTransfer.files;

    if (this._upfile.files.length === 0) {
      console.error('Ошибка: файлы не добавлены в this._upfile.files');
      alert('Ошибка: файлы не добавлены для загрузки');
      this.reload();
      return;
    }

    const fileNames = Array.from(this._upfile.files)
      .map((file) => file.name)
      .join(', ');
    console.log('Файлы успешно добавлены:', fileNames);

    this._updrop.innerText = fileNames;

    this.target.closest('fieldset').updateData();
    this._upfile.dispatchEvent(new Event('change'));
  }

  then(func) {
    this._exp_handeler.then(func);
    this._then = false;
    return this._exp_handeler;
  }

  // запуск события при изменении
  _onChange() {
    if (!this.uplock && this._upfile.files.length !== 0) {
      this.uplock = true;

      // Меняем текст зоны дропа на имена всех файлов
      const fileNames = Array.from(this._upfile.files)
        .map((file) => file.name)
        .join(', ');
      this._updrop.innerText = fileNames;

      const fieldset = this.target.closest('fieldset');
      fieldset.hardUpdateData();

      if (this.action) this.action(this);
      this.reload();
      // console.log('filedset_relodid');
    }
  }
}
